"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _conductor = require("@virtuous/conductor");

var _useRoute2 = _interopRequireDefault(require("../useRoute"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function RouteNotFound(_ref) {
  var Component = _ref.component;

  var _useRoute = (0, _useRoute2["default"])(),
      pathname = _useRoute.pathname;

  if (_conductor.router.match(pathname)) {
    return null;
  }

  return _react["default"].createElement(Component, null);
}

var _default = RouteNotFound;
exports["default"] = _default;